import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DocumentChangedInfo, FormComponent, FormDocument, FormTemplate } from '@formbird/types';
import { ConfigService } from '@services/config/config.service';
import { BroadcastService } from '../../../../formbird-services/src/lib/services/broadcast/broadcast.service';
import { AuditTableComponentDefinition } from './audit-table.component.definition';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import { SearchService } from '../../../../formbird-services/src/lib/services/search/search.service';
import { ClientRulesService } from '../../../../formbird-services/src/lib/services/rules/client-rules.service';
import { SclUtilAuditService } from '../../../../formbird-sc-shared/src/lib/scl-util-audit.service';
import { UtilSharingNgService } from '../../../../formbird-sc-shared/src/lib/util-sharing-ng.service';
import { Observable, Subscription } from 'rxjs';
import { sclHandlebars } from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import * as $ from 'jquery';
import * as moment from 'moment';
import { UtilDocumentId } from '@formbird/shared';
import { DataTableImport } from '../../../../sc-datatables/src/app/datatables/datatables.import';
import { CellTemplateServices } from '../../../../formbird-sc-shared/src/lib/cell-template.service';

const logger = console;

@Component({
  templateUrl: './audit-table.component.html',
  styleUrls: ['./audit-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditTableComponent implements FormComponent, OnInit, OnDestroy, AfterViewInit {
  @Input() document: FormDocument;
  @Input() fieldValue: any;
  @Input() template: FormTemplate;
  @Input() fieldName: string;
  @Input() formParameters: any;
  @Input() key: number;
  @Input() message: string;
  @Input() componentDefinition: AuditTableComponentDefinition;
  @Input() floatLabel: any;
  @Input() docs: object = {};

  @ViewChild('divDiffContainer', { static: false }) divDiffContainer: ElementRef;
  @ViewChild('dataTable', { static: false }) table: any;
  // service
  notificationService: any;
  auditService: any;
  currentDocumentService: any;
  documentService: any;
  dataService: any;
  loggedInUserService: any;
  modalService: any;

  //
  disabled: boolean;
  hideRequired: boolean;
  isRequired: boolean;

  //
  keyName;
  sharedValue;
  initialValueDisplay = '...';
  newValueDisplay = '...';
  isHasTargetTableComponent = false;
  totalVersion = 0;
  isProcessing = false;
  contextParams: any;

  numberOfVersions = 100;
  fromVersion = 0;
  toVersion = 10;
  max = 0;
  min = 0;
  step = 10;
  useLabels = false;
  label;
  columns;
  currentTemplateComponentsObj;
  allVersionDataObj;
  resultUserDataObj;
  dataTable;
  wrapText;
  docId;
  htmlTBodyTrValues = '';
  isFirstReload = false;
  dataTest = ['test1', 'test2'];
  rawDocumentVersionList;
  versionList = [];
  type = 'initial';
  rowItemsPagination = null;
  pagingPrev = '<<';
  totalPaging = 20;
  isReloadOnce: boolean;
  isFieldView;
  groupLabel: String;
  includeSystemHeader: boolean = false;
  fieldNameSelector: any;
  pagingNo = [];
  pagingNext = '>>';
  lengthMenu = [10, 25, 50, 100];
  rowsPerPage = 10;
  account;
  currentSelectedPage = 1;
  functionListToBeCalledInPublic;
  intervalRequestDatatables; // for angular version to waiting datatables finish loading
  countRequestDatatables; // limit number of time calling request datatables
  intervalRequestFadeIn; // for angular version to request 'back-drop fade in' div when double click an item on table

  //
  private registeredControlName;
  private subs: Subscription = new Subscription();

  constructor(
    private cdRef: ChangeDetectorRef,
    private elRef: ElementRef,
    private searchService: SearchService,
    private changedDocumentService: ChangedDocumentService,
    private formbirdInjectorService: FormbirdInjectorService,
    private clientRulesService: ClientRulesService,
    private sclUtilAuditService: SclUtilAuditService,
    private utilSharingNgService: UtilSharingNgService,
    private configService: ConfigService,
    private broadcastService: BroadcastService,
    private cellTemplateServices: CellTemplateServices
  ) {
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.auditService = this.formbirdInjectorService.get('AuditService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.modalService = this.formbirdInjectorService.get('ModalService');
  }

  ngOnInit() {
    this.account = this.loggedInUserService.user.account;
    this.registeredControlName = this.fieldName + this.key + UtilDocumentId.generateId();
    if (!(typeof this.componentDefinition.fieldView === 'undefined' || this.componentDefinition.fieldView === null)) {
      this.isFieldView = this.componentDefinition.fieldView;
    } else {
      this.isFieldView = false;
    }

    if (this.componentDefinition.groupLabel) {
      this.groupLabel = this.componentDefinition.groupLabel;
    } else {
      this.groupLabel = null;
    }

    if(this.componentDefinition.includeSystemHeader){
      this.includeSystemHeader = this.componentDefinition.includeSystemHeader;
    }

    if(this.componentDefinition.fieldNameSelector){
      this.fieldNameSelector = this.componentDefinition.fieldNameSelector;
    }

    if (this.document && this.document[this.componentDefinition.name]) {
      this.docs[this.fieldName] = this.document[this.componentDefinition.name];
      this.fieldValue = this.document[this.componentDefinition.name];
    }

    if (!(typeof this.componentDefinition.mandatory === 'undefined' || this.componentDefinition.mandatory === null)) {
      this.isRequired = this.componentDefinition.mandatory;
    } else {
      this.isRequired = false;
    }
    this.hideRequired = !this.isRequired;
    this.componentDefinition = this.template.components[this.key];

    this.sharedValue = this.clientRulesService.getSharedValue('person');
    this.clientRulesService.setSharedValue('DataListObject', {
      fielName: this.fieldName,
      dataAuditObject: null,
      total: 0,
      time: new Date().getTime(),
    });
    this.clientRulesService.setSharedValue('TriggerModal', {
      TriggerModalId: '#btnTriggerModalPublic' + this.fieldName + this.key,
    });
    this.clientRulesService.setSharedValue('TriggerReloadAudit', {
      TriggerReloadAuditId: '#btnTableReload' + this.fieldName + this.key,
    });
    this.label = this.componentDefinition.label;
    this.componentDefinition.labels = ['No', 'Who', 'When', 'Initial', 'New'];
    if (!(typeof this.componentDefinition.targetTable === 'undefined' || this.componentDefinition.targetTable === null)) {
      for (const comp of this.template.components) {
        if (comp.name === this.componentDefinition.targetTable) {
          this.isHasTargetTableComponent = true;
        }
      }
    }

    if (this.componentDefinition.useLabels || this.isFieldView) {
      this.useLabels = true;
    }
    this.wrapText = 'wrapText';
    if (!(typeof this.componentDefinition.enforceWidth === 'undefined' || this.componentDefinition.enforceWidth === null)) {
      if (this.componentDefinition.enforceWidth === true) {
        this.wrapText = 'wrapText';
      } else {
        this.wrapText = '';
      }
    }
    this.docId = this.document.documentId;

    this.functionListToBeCalledInPublic = [
      {
        name: 'eventReloadTable',
        fn: this.eventReloadTable.bind(this),
      },
      {
        name: 'eventDoubleClickRowValue',
        fn: this.eventDoubleClickRowValue.bind(this),
      },
      {
        name: 'setDataTest',
        fn: this.setDataTest.bind(this),
      },
      {
        name: 'getDataTest',
        fn: this.getDataTest.bind(this),
      },
    ];
    this.utilSharingNgService.fnRegisterFunctions(this.functionListToBeCalledInPublic, this.fieldName, this.document.documentId);

    const documentChangedInfo: DocumentChangedInfo = {
      documentId: this.document.documentId,
      fieldName: this.fieldName,
      newValue: this.fieldValue,
      isInitValue: true,
    };
    this.changedDocumentService.notifyDocumentChanged(documentChangedInfo);

    this.componentSubscription();

    this.loadAllUser();
    this.loadCurrentTemplateComponents();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngAfterViewInit() {
    console.log('afterviewinit');
    const importDatatable = new DataTableImport();
    importDatatable.isRowGroup = this.isFieldView;
    importDatatable.isSelect = false;

    importDatatable.loadExtensions().then(() => {
      if (!this.isHasTargetTableComponent) {
        this.initDatatable();
      }
      this.loadAuditHistory('initial'); // 14789
      // watched function for getSharedData Processing_
      const self = this;
      const dataListObject = new Observable((observer) => {
        observer.next(self.clientRulesService.getSharedValue('Processing_' + self.fieldName));
        observer.complete();
      });
      dataListObject.subscribe({
        next: (change) => {
          const newValue = change as any; // change.newValue;
          if (newValue) {
            if (newValue.objectDataValue) {
              setTimeout(() => {
                self.isProcessing = false;
              }, 100);
            }
          }
        },
      });
    });
  }

  componentSubscription() {
    const docSub = this.changedDocumentService
      .watch(this.fieldName, this.document.documentId, this.registeredControlName)
      .subscribe((fieldValue) => {
        if (this.fieldValue === fieldValue) {
          return;
        }
        const json = JSON.stringify(fieldValue);
        this.fieldValue = JSON.parse(json);
        console.log('watch document, fieldValue = ' + fieldValue);
        // this.watchDoc(fieldValue);
      });

    const compSub = this.changedDocumentService.watchComponentTemplate(this.template.documentId).subscribe((components) => {
      components
        .filter((tplItem) => tplItem.name === this.fieldName)
        .forEach((tplItem) => {
          this.componentDefinition = tplItem;
        });
    });

    this.isReloadOnce = true;
    const updatedSub2 = this.broadcastService.on('document:updated').subscribe((obj) => {
      if (obj) {
        this.isReloadOnce = !this.isReloadOnce;
        if (this.isReloadOnce) {
          this.eventReloadTable();
        }
      }
    });

    this.subs.add(docSub);
    this.subs.add(compSub);
    this.subs.add(updatedSub2);
  }

  valueChanged(value) {
    this.changedDocumentService.valueChanged(this, value, this.registeredControlName);
  }

  loadAllUser() {
    const searchOptions: any = {
      page: 0,
      pageSize: 1000,
    };
    searchOptions.sourceFilter = {
      include: ['documentId', 'systemHeader.summaryName'],
    };
    searchOptions.filter =
      "{'query':{'bool':{'filter':[{'term':" + "{'systemHeader.systemType': 'account'}},{'term':{'documentId':'{{userId}}'}}]}}}";
    searchOptions.filter = searchOptions.filter.replace(",{'term':{'documentId':'{{userId}}'}}", '');
    this.searchService.search(searchOptions).then(
      (data) => {
        // LOOPING THROUGH THE RESULTS IMPACTS PERFORMANCE OF THE SEARCH DRASTICALLY. ANY FILTERING SHOULD
        // BE DONE IN THE SEARCH QUERY SENT TO ELASTICSEARCH, SO NO LOOPING SHOULD BE ADDED HERE

        // just assign the scope value directly to the returned data with no modification

        this.resultUserDataObj = data.data.hits.hits;
      },
      (err) => {
        console.log('error on Loading Users Data:' + err);
      }
    );
  }

  loadCurrentTemplateComponents() {
    const searchOptions: any = {
      page: 0,
      pageSize: 1000,
    };
    searchOptions.sourceFilter = {
      include: ['components'],
    };
    const filterQuery = JSON.stringify({
      query: {
        bool: {
          filter: [
            { term: { 'systemHeader.systemType': 'template' } },
            { term: { documentId: this.document.systemHeader.templateId } },
          ],
        },
      },
    });
    searchOptions.filter = filterQuery;
    this.searchService.search(searchOptions).then(
      (data) => {
        // LOOPING THROUGH THE RESULTS IMPACTS PERFORMANCE OF THE SEARCH DRASTICALLY. ANY FILTERING SHOULD
        // BE DONE IN THE SEARCH QUERY SENT TO ELASTICSEARCH, SO NO LOOPING SHOULD BE ADDED HERE

        // just assign the scope value directly to the returned data with no modification
        this.currentTemplateComponentsObj = data.data.hits.hits;
      },
      (err) => {
        console.log('error on Loading Current Template Components:' + err);
      }
    );
  }

  displayDiff(baseDoc, newDoc, baseVersion, newVersion) {
    const diffHtml = this.auditService.getDiff(baseDoc, newDoc, baseVersion, newVersion);
    diffHtml.then(
      (html: any) => {
        // console.log('%c displayDiff, html = ' + html, 'color:blue');
        $('.diff-container-audit-table').empty().append(html);
        this.cdRef.detectChanges();
        this.showVersionComparison();
      },
      (err) => {
        console.log('display Diff error = ', err);
      }
    );
  }
  processDataDiff(data, index) {
    const object1 = data[index];
    let object2 = data[index];
    if (data.length > 1 && index < data.length - 1) {
      object2 = data[index + 1];
    }
    // $timeout(function () {
    // logger.info(data, object1,object2);

    let createByEmailName1 = this.getUser(object1.systemHeader.createdBy, this.resultUserDataObj);
    let createByEmailName2 = this.getUser(object2.systemHeader.createdBy, this.resultUserDataObj);
    createByEmailName1 = createByEmailName1 ? createByEmailName1.systemHeader.summaryName : object1.systemHeader.createdBy;
    createByEmailName2 = createByEmailName2 ? createByEmailName2.systemHeader.summaryName : object2.systemHeader.createdBy;

    this.displayDiff(
      JSON.stringify(object1, null, 4).replace(/\\n/g, '\n'),
      JSON.stringify(object2, null, 4).replace(/\\n/g, '\n'),
      object1.systemHeader.versionId +
        '\n' +
        this.formatTime(object1.systemHeader.createdDate) +
        ' \nCreated By: ' +
        createByEmailName1,
      object2.systemHeader.versionId +
        '\n' +
        this.formatTime(object2.systemHeader.createdDate) +
        ' \nCreated By: ' +
        createByEmailName2
    );
  }
  formatTime(time) {
    let dateFormat = null;
    const clientConfig = this.configService.clientConfig();
    if (clientConfig && clientConfig.dateFormat) {
      dateFormat = clientConfig.dateFormat;
    }
    let longDate;

    // check that the dateFormat is there before accessing values
    if (dateFormat && dateFormat.longDate) {
      longDate = dateFormat.longDate;
    } else {
      longDate = 'MMM DD YYYY, h:mm:ss a';
    }

    return moment(time).fromNow() + ' (' + moment(time).format(longDate) + ')';
  }

  initDatatable() {
    let isVisible = this.isFieldView ? false : true;
    this.columns = [
      {
        data: 'no',
        title: 'No',
        field: 'no',
        visible: isVisible,
      },
      {
        data: 'who',
        title: 'Who',
        field: 'who',
        visible: isVisible,
      },
      {
        data: 'when',
        title: 'When',
        field: 'when',
        visible: isVisible,
      },
      {
        data: 'field',
        title: 'Field',
        field: 'field',
        visible: this.isFieldView ? true : false,
      },
      {
        data: 'status',
        title: 'Status',
        field: 'status',
        visible: this.isFieldView ? true : false,
      },
      {
        data: 'initial',
        field: 'initial',
        title: 'Initial',
        visible: true,
      },
      {
        data: 'new',
        title: 'New',
        field: 'new',
        visible: true,
      },
    ];
    const self = this;
    this.dataTable = $(this.table.nativeElement);
    if (!this.isFieldView) {
      this.table = this.dataTable.DataTable({
        scrollX: true,
        lengthMenu: this.lengthMenu,
        pageLength: 10,
        bProcessing: true,
        bServerSide: false,
        dom: 'rt<"dataTable-footer"<"info"i><"pagination"p>>',
        autoWidth: false,
        deferRender: true,
        language: {
          paginate: {
            previous: '&lt;',
            next: '&gt;',
          },
        },
        columns: this.columns,
      });
    } else {
      this.table = this.dataTable.DataTable({
        lengthMenu: this.lengthMenu,
        scrollX: true,
        pageLength: 10,
        bProcessing: true,
        bServerSide: false,
        rowGroup: {
          dataSrc: 'groupKey',
          startRender: function (rows, group, meta) {
            const firstRow = rows.data()[0];
            let groupVersion = Number(firstRow['no']) - 1;

            self.contextParams = {
              currentDoc: self.allVersionDataObj[groupVersion],
              previousDoc: self.allVersionDataObj[groupVersion + 1],
              doc: self.document,
              tpl: self.template,
              currentAccount: self.account,
              fieldName: self.fieldName,
              template: self.template,
              tplItem: self.componentDefinition, // For BackCompatibility
              componentDefinition: self.componentDefinition, // the current components configuration details
            };

            if (self.groupLabel) {
              const handlebarsContext = {
                results: null,
                resultsCount: -1,
                resultsIndex: meta.row,
                queryResultDocument: firstRow,
                ...self.contextParams,
              };

              let cellHtml = sclHandlebars.processHandlebars(self.groupLabel, handlebarsContext, null);
              return self.cellTemplateServices.renderCell(cellHtml);
            } else {
              return `<strong> ${firstRow.no}, ${firstRow.when} by User Account ${firstRow.who}</strong>`;
            }
          },
        },
        dom: 'rt<"dataTable-footer"<"info"i><"pagination"p>>',
        autoWidth: false,
        deferRender: true,
        language: {
          paginate: {
            previous: '&lt;',
            next: '&gt;',
          },
        },
        columns: this.columns,
      });
    }

    this.table.on('click', 'tr', function (e) {
      e.stopPropagation();
      // if ($(this).hasClass('selectedSingleClick')) {
      //   // $(this).removeClass('selectedSingleClick');
      //   console.log($(this), 'Already selectedSingleClick');
      // } else {
      //   $(self.elRef.nativeElement).find('table tr.selectedSingleClick').removeClass('selectedSingleClick');
      //   $(this).addClass('selectedSingleClick');
      // }
    });
    this.table.on('dblclick', 'tr', function (e) {
      e.stopPropagation();
      if ($(this).hasClass('dtrg-group')) {
        e.preventDefault();
        return;
      }
      if ($(this).hasClass('selected')) {
        // $(this).removeClass('selected');
        console.log($(this), 'Already selected');
        self.hideDivFadeIn();
      } else {
        $(self.elRef.nativeElement).find('table tr.selected').removeClass('selected');
        $(this).addClass('selected');
        console.log($(this), 'New Row Selected');
        self.hideDivFadeIn();
      }
      self.eventDoubleClickRow();
    });
  }

  fnLoadDataTable(docVersionData, type) {
    if (!docVersionData) {
      return;
    }

    let objectDataSet = this.sclUtilAuditService.getObjectVersionData(
      docVersionData,
      this.getUser.bind(this),
      this.formatTime.bind(this),
      this.getLabelsFromTemplate.bind(this),
      this.resultUserDataObj,
      this.currentTemplateComponentsObj,
      this.isFieldView,
      this.isHasTargetTableComponent
    );
    let proccessedData = [];

    if (type === 'reload') {
      if (this.isHasTargetTableComponent) {
        let gridColumns;
        $.each(this.template.components, (compKey, compValue: any) => {
          if (compValue.name === this.componentDefinition.targetTable) {
            gridColumns = compValue.gridColumns.filter((gridColumn) => this.shouldIncludeField(gridColumn.field));
          }
        });
        let holderObjectDataSet = this.proccessData(objectDataSet, gridColumns);
        this.utilSharingNgService.fnPassedDataObject(
          this.componentDefinition.targetTable,
          'DataListObject_' + this.componentDefinition.targetTable,
          holderObjectDataSet
        );
        this.broadcastService.broadcast('DataListObject_' + this.componentDefinition.targetTable, {
          fieldName: this.componentDefinition.targetTable,
          objectDataValue: holderObjectDataSet,
          time: new Date().getTime(),
        });
      } else {
        // Init paging function
        proccessedData = this.proccessData(objectDataSet, this.columns);
      }
    } else {
      // Init paging function
      proccessedData = this.proccessData(objectDataSet, this.columns);
    }

    if (this.isFieldView) {
      proccessedData = proccessedData.map((row) => ({
        ...row,
        groupKey: `${row.docId} - ${row.when} - ${row.who}`, // Combine columns
      }));
    }

    if (!this.isHasTargetTableComponent) {
      this.table.clear().rows.add(proccessedData).draw();
    }

    this.cdRef.detectChanges();
  }

  proccessData(objectDataSet, gridColumns) {
    const holderObjectDataSet = [];
    let total = 0;
    this.totalVersion = total;

    $.each(objectDataSet, (key, value) => {
      if (this.isFieldView) {
        if (value[3] == 'Created') {
          let keys = Object.keys(value[5]);
          for (let key of keys) {
            let regex = /\(([^)]+)\)\s*(.+)/;
            let match = regex.exec(key);
            if (match) {
              if (!this.shouldIncludeField(match[2])) continue;

              if(match[1] == 'sc-party'){
                let keys = Object.keys(value[5][key]);
                keys.forEach((newKey) => {
                  this.addRows(
                    holderObjectDataSet,
                    gridColumns,
                    value,
                    this.stripQuotes(match[2]) + '.' + newKey,
                    'No Initial Value',
                    value[5][key][newKey],
                    'Created'
                  );
                })
              }else if (match[1] == 'sc-related-document') {
                let len = value[5][key] && value[5][key].length ? value[5][key].length : 0;
                for (let i = 0; i < len; i++) {
                  this.addRows(
                    holderObjectDataSet,
                    gridColumns,
                    value,
                    this.stripQuotes(match[2]) + '.' + i,
                    'No Initial Value',
                    value[5][key][i].name,
                    'Created'
                  );
                }
              } else {
                this.addRows(
                  holderObjectDataSet,
                  gridColumns,
                  value,
                  this.stripQuotes(match[2]),
                  'No Initial Value',
                  value[5][key],
                  'Created'
                );
              }
            } else {
              if (key == 'systemHeader') {
                let keys = Object.keys(value[5][key]);
                for (let secondKey of keys) {
                  if (!this.shouldIncludeField(this.stripQuotes(key) + '.' + secondKey)) continue;
                  this.addRows(
                    holderObjectDataSet,
                    gridColumns,
                    value,
                    this.stripQuotes(key) + '.' + secondKey,
                    'No Initial Value',
                    value[5][key][secondKey],
                    'Created'
                  );
                }
              } else {
                if (!this.shouldIncludeField(key)) continue;
                this.addRows(
                  holderObjectDataSet,
                  gridColumns,
                  value,
                  this.stripQuotes(key),
                  'No Initial Value',
                  value[5][key],
                  'Created'
                );
              }
            }
          }
        } else {
          let fields = this.extractFields(value[3], value[4]);
          fields.forEach((field: { field: string; old: string; new: string; status: string }) => {
            this.addRows(holderObjectDataSet, gridColumns, value, field.field, field.old, field.new, field.status);
          });
        }
      } else {
        this.addRows(holderObjectDataSet, gridColumns, value);
      }

      total = holderObjectDataSet.length;
    });
    setTimeout(() => {
      this.totalVersion = total;
    }, 100);
    return holderObjectDataSet;
  }

  getValueForField(holderGridColumns, gridColValue, value, field?, old?, newValue?, fieldStatus?) {
    if (gridColValue.field === 'no') {
      holderGridColumns[gridColValue.field] = value[0];
    } else if (gridColValue.field === 'who') {
      holderGridColumns[gridColValue.field] =  value[1];
    } else if (gridColValue.field === 'when') {
      holderGridColumns[gridColValue.field] =  value[2];
    } else if (gridColValue.field === 'initial') {
      holderGridColumns[gridColValue.field] =  this.isFieldView ? old : value[3];
    } else if (gridColValue.field === 'new') {
      holderGridColumns[gridColValue.field] =  this.isFieldView ? newValue : value[4];
    } else if (gridColValue.field == 'field') {
      holderGridColumns[gridColValue.field] =  this.isFieldView ? field : 'unknown';
    } else if (gridColValue.field == 'status') {
      holderGridColumns[gridColValue.field] =  this.isFieldView ? fieldStatus : 'unknown';
    }  else {
      const fieldArrayList = gridColValue.field.split('.');
      if (fieldArrayList.length === 1) {
        holderGridColumns[gridColValue.field] = value[5][fieldArrayList[0]];
      } else if (fieldArrayList.length === 2) {
        holderGridColumns[fieldArrayList[1]] = value[5][fieldArrayList[0]][fieldArrayList[1]];
      } else if (fieldArrayList.length === 3) {
        holderGridColumns[fieldArrayList[2]] = value[5][fieldArrayList[0]][fieldArrayList[1]][fieldArrayList[2]];
      }
    }
  }

  addRows(holderObjectDataSet, gridColumns, value, field?, old?, newValue?, fieldStatus?) {
    const holderGridColumns = [];
    $.each(gridColumns, (gridColKey, gridColValue) => {
      this.getValueForField(holderGridColumns, gridColValue, value, field, old, newValue, fieldStatus);
    });
    holderObjectDataSet.push(holderGridColumns);
  }

  shouldIncludeField(key) {
    let shouldInclude = true;

    if (key.includes('systemHeader') && !this.includeSystemHeader) {
      return false;
    }
    let fields = key.split('.');
    let length = fields.length - 1;

    if (!isNaN(fields[length])) {
      //sc-related
      key = fields[length - 1];
    } else {
      key = fields[length];
    }

    if (key == '_id') {
      return false;
    }
    if(this.fieldNameSelector){
      try {
        let matches = this.fieldNameSelector.match(/^\/(.+)\/([a-z]*)$/);
        if (matches) {
          let pattern = matches[1];
          let flags = matches[2];
          const regex = new RegExp(pattern, flags);

          return regex.test(key);
        } else {
          const regex = new RegExp(this.fieldNameSelector);
          return regex.test(key);
        } 
      }catch(error){
        console.log('fieldNameSelector is not a valid RegExp or string.');
        return false;
      }
    }
    return shouldInclude;
  }

  extractFields(old, newValue) {
    const regexNew = /(?:\(([^)]+)\)\s*)?(.+?):\s*("[^"]+"|\[[^\]]*\]|\{[^\}]*\}|[^,]+)\s*\((New|Updated)\)/g;
    const regexOld = /(?:\(([^)]+)\)\s*)?(.+?):\s*("[^"]+"|\[[^\]]*\]|\{[^\}]*\}|[^,]+)\s*/g;
    const regexDeleted = /\(([^)]+)\)\s*(.+?)\s\((Deleted)/g;

    const fields = {};
    let match;

    const oldValueField = old.trim().split('\n');

    oldValueField.forEach((oldField) => {
      while ((match = regexOld.exec(oldField)) !== null) {
        const key = match.length === 2 ? match[1] : match[2];
        const oldValue = match.length === 2 ? this.formatFieldValue(null, match[2]) : this.formatFieldValue(match[1], match[3]);
        if (!this.shouldIncludeField(key)) continue;
        fields[key] = {
          field: this.stripQuotes(key),
          old: oldValue,
          new: null,
          status: null,
        };
      }
    });

    const newValueField = newValue.trim().split('\n');
    newValueField.forEach((newField) => {
      while ((match = regexNew.exec(newField)) !== null) {
        const component = match.length === 3 ? null : match[1];
        const key = match.length === 3 ? match[1] : match[2];
        const value = match.length === 3 ? match[2] : match[3];
        const status = match.length === 3 ? match[3] : match[4];
        if (!this.shouldIncludeField(key)) continue;

        if (
          component === 'sc-party' &&
          status === 'New' &&
          (() => {
            try {
              return typeof JSON.parse(value) === 'object' && JSON.parse(value) !== null;
            } catch (e) {
              return false;
            }
          })()
        ) {
          if (fields[key]) {
            delete fields[key];
          }
          let newValue = JSON.parse(value);
          let keys = Object.keys(newValue);
          keys.forEach((insideKey) => {
            let newKey = key + '.' + insideKey;

            fields[newKey] = {
              field: this.stripQuotes(newKey),
              old: 'No Initial value',
              new: this.formatFieldValue(component, JSON.stringify(newValue[insideKey])),
              status: status,
            };
          });
        } else if (
          component == 'sc-related-document' &&
          status == 'New' &&
          (() => {
            try {
              return typeof JSON.parse(value) === 'object' && Array.isArray(JSON.parse(value));
            } catch (e) {
              return false;
            }
          })()
        ) {
          if (fields[key]) {
            delete fields[key];
          }
          let parseValue = JSON.parse(value);
          for (let i = 0; i < parseValue.length; i++) {
            let newKey = key + '.' + i;
            fields[newKey] = {
              field: this.stripQuotes(newKey),
              old: 'No Initial value',
              new: this.formatFieldValue(component, JSON.stringify(parseValue[i])),
              status: status,
            };
          }
        } else {
          if (!fields[key]) {
            fields[key] = {
              field: this.stripQuotes(key),
              old: null,
              new: this.formatFieldValue(component, value),
              status: status,
            };
          } else {
            fields[key].new = this.formatFieldValue(component, value);
            fields[key].status = status;
          }
        }
      }
    });

    newValueField.forEach((newField) => {
      while ((match = regexDeleted.exec(newField)) !== null) {
        if (!this.shouldIncludeField(match[2])) continue;
        if (!fields[match[2]]) {
          fields[match[2]] = { field: this.stripQuotes(match[2]), old: null, new: null, status: match[3] };
        } else {
          fields[match[2]].status = match[3];
        }
      }
    });

    type Field = {
      field: string;
      old: string;
      new: string;
      status: string;
    };
    return Object.values(fields).filter((field: Field) => field.field !== 'lastUpdated');
  }

  stripQuotes(value) {
    return value.replace(/"/g, '');
  }

  formatFieldValue(componentName, value) {
    if (componentName == 'sc-related-document') {
      try {
        let parseValue = JSON.parse(value);
        return this.stripQuotes(parseValue.name);
      } catch (err) {
        return this.stripQuotes(value);
      }
    } else {
      return this.stripQuotes(value);
    }
  }

  selectPageLengthChange(length) {
    let newlength = parseInt(length);
    this.table.page.len(newlength).draw();
  }

  search(event) {
    let searchVal = $(event.target).val();
    this.table.search(searchVal).draw();
  }

  reload() {
    this.table.ajax.reload();
  }
  calculatePaging(dataSetLen) {
    const totalPage = Math.ceil(dataSetLen / 10);
    this.pagingInitFunction(totalPage, dataSetLen);
    this.pagingLoadRecordFunction(null, 1);
  }
  hideDivFadeIn() {
    if (this.intervalRequestFadeIn == null) {
      this.intervalRequestFadeIn = setInterval(() => {
        // hide div 'modal-backdrop fade in'
        const divs: any = document.getElementsByClassName('modal-backdrop');
        if (divs && divs.length > 0) {
          clearInterval(this.intervalRequestFadeIn);
          this.intervalRequestFadeIn = null; // reset
          for (const div of divs) {
            div.style.display = 'none';
          }
        }
      }, 200);
    }
  }
  eventDoubleClickRow() {
    let selectedRowData = this.table.rows('.selected').data()[0];
    const rowIndex = Number(selectedRowData['no']) - 1;
    this.processDataDiff(this.allVersionDataObj, rowIndex);
    $('#idElemObjectChanges').text(selectedRowData['initial']).text();
    $('#idElemTypeChanges').text(selectedRowData['final']).text();
    $('.diff-container-audit-table table th:last').css('color', '#EFEFEF');
    $('.diff-container-audit-table table th:last a').css('color', '#EFEFEF');
  }
  eventDoubleClickRowValue() {
    let pushedValue;
    if (this.isHasTargetTableComponent) {
      pushedValue = this.utilSharingNgService.fnGetDataObject(this.componentDefinition.targetTable, 'PushedRowValue')
        .objectDataValue;
    }
    if (pushedValue) {
      this.initialValueDisplay = pushedValue[3];
      this.newValueDisplay = pushedValue[4];
      const rowIndex = pushedValue[0] - 1;
      this.processDataDiff(this.allVersionDataObj, rowIndex);
      this.initialValueDisplay = pushedValue[3];
      this.newValueDisplay = pushedValue[4];

      $('.diff-container-audit-table table th:last').css('color', '#EFEFEF');
      $('.diff-container-audit-table table th:last a').css('color', '#EFEFEF');
      this.hideDivFadeIn();
    }
  }

  showVersionComparison() {
    const data = {
      messageType: 'info',
      confirmButtonText: 'Close',
      showCloseButton: true,
      confirmButton: true,
      showCancelButton: false,
      allowEnterKey: false,
      title: 'Document Version Difference',
    };

    this.modalService.openDialog({ data });

    // :::Style Format of on the fly Modal Popup:::
    $('mat-dialog-content').empty();
    $('div#idOpenModalVersionComparison .modal-body .diff-container-audit-table').not(':first').remove();
    $('div#idOpenModalVersionComparison .modal-body .diff-container-audit-table').clone().appendTo('mat-dialog-content');
    $('mat-dialog-content .card-body').css({ 'padding-top': '6px', 'padding-bottom': 0 });
    $('mat-dialog-content .card-title').css({ 'font-size': '14px', 'margin-bottom': 0 });
    $('mat-dialog-content .author').css('display', 'none');
    $('mat-dialog-content .mat-dialog-actions').css('box-shadow', '0 8px 17px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19)');
    $('.mat-dialog-content').css({ overflow: 'scroll', display: 'block' });
    //  $('mat-dialog-actions').appendTo('mat-dialog-content');
    $('.cdk-overlay-pane').css({ 'max-width': '95vw', height: '100%' });
    // :::End of  Style Format:::
  }

  eventReloadTable() {
    this.fnGetDocumentById('reload');
  }
  getDataTest() {
    // logger.info('getting of data',scope.dataTest);
    return this.dataTest;
  }
  setDataTest(data) {
    this.dataTest = data;
    console.log('dataTest is modified', this.dataTest);
    this.clientRulesService.setSharedValue('setDataTest', { fieldName: this.fieldName, param1: this.dataTest, time: new Date() });
  }
  getUser(userId, userDataObject) {
    let dataObject = null;
    userDataObject = userDataObject ? userDataObject : this.resultUserDataObj;
    if (userDataObject) {
      userDataObject.find(function searchUserInsideResultUserData(dataInside) {
        if (dataInside._source.documentId === userId) {
          dataObject = dataInside._source;

          return dataObject;
        }
      });
    }
    return dataObject;
  }
  getLabelsFromTemplate(fieldName, documentDataTemplate) {
    let dataLabelName = fieldName;
    const arrayHolderDuplicateLabel = [];
    if (documentDataTemplate) {
      const cntDuplicate = 0;
      documentDataTemplate[0]._source.components.find((dataInside) => {
        if (dataInside.label) {
          arrayHolderDuplicateLabel.push(dataInside.label);
        } else {
          arrayHolderDuplicateLabel.push('');
        }
      });
      documentDataTemplate[0]._source.components.find((dataInside) => {
        let cntTemp = 0;
        arrayHolderDuplicateLabel.find((dataInsideDup) => {
          if (dataInside.label === dataInsideDup) {
            cntTemp++;
          }
        });

        if (dataInside.name === fieldName && this.useLabels) {
          let componentName = '';
          if (this.isFieldView) {
            //add component name
            componentName = '(' + dataInside.componentName + ')' + ' ';
          }

          if (dataInside.label) {
            dataLabelName = componentName + '"' + dataInside.label + '"';
          } else {
            dataLabelName = componentName + '"' + dataInside.name + '"';
          }
          if (cntTemp > 1) {
            dataLabelName = componentName + '"' + dataInside.name + '"' + dataInside.label + '"';
          }
          return dataLabelName;
        }
      });
    }

    return dataLabelName;
  }
  loadAuditHistory(type) {
    switch (type) {
      case 'reload':
        // var table = scope.datatable;
        // table.clear().draw();
        $(this.elRef.nativeElement)
          .find('.dataTables_empty')
          .html('<div id="sc-datatables-test_processing" class="dataTables_processing panel panel-default" >Processing...</div>');
        // fnGetDocumentInAuditService(type);
        this.fnGetDocumentById(type);
        // setTimeout(() => {
        //   this.fnLoadDataTable(this.allVersionDataObj, type);
        // }, 1000);
        // this.fnLoadDataTable(this.allVersionDataObj, type);
        break;
      default:
        // fnGetDocumentInAuditService(type);
        $(this.elRef.nativeElement)
          .find('.dataTables_empty')
          .html('<div id="sc-datatables-test_processing" class="dataTables_processing panel panel-default" >Processing...</div>');
        this.fnGetDocumentById(type);
      // setTimeout(() => {
      //   this.fnLoadDataTable(this.allVersionDataObj, type);
      // }, 1000);
      // this.fnLoadDataTable(this.allVersionDataObj, type);
    }
  }

  checkDatatablesComponentDoneLoading(type) {
    if (this.allVersionDataObj == null || this.allVersionDataObj.length === 0) {
      return;
    }
    if (this.intervalRequestDatatables == null) {
      this.countRequestDatatables = 0;
      this.intervalRequestDatatables = setInterval(() => {
        const rows = $('#' + this.componentDefinition.targetTable).find('tbody>tr');
        if (rows && rows.length > 0) {
          console.log('datatables component done loading !!!');
          clearInterval(this.intervalRequestDatatables);
          this.intervalRequestDatatables = null; // reset
          this.countRequestDatatables = 0; // reset
          this.fnLoadDataTable(this.allVersionDataObj, type);
        } else {
          console.log("datatables component hasn't done loading yet ...");
          this.countRequestDatatables++;
          if (this.countRequestDatatables > 11) {
            clearInterval(this.intervalRequestDatatables);
            this.intervalRequestDatatables = null; // reset
            this.countRequestDatatables = 0; // reset
            console.log('there has no sc-datatables component or sc-datatables component has invalid table ');
          }
        }
      }, 200);
    }
  }
  fnGetDocumentInAuditService(type) {
    this.auditService.getVersions(this.docId).then(
      (data) => {
        if (data) {
          this.allVersionDataObj = data;
          setTimeout(() => {
            console.log('%c fnGetDocumentInAuditService', 'color:green');
            this.fnLoadDataTable(this.allVersionDataObj, type);
          }, 1000);
        }
      },
      (err) => {}
    );
  }
  fnProcessDocumentList(object, type) {
    const dataObject = [];
    const holderVersionDataObj = [];
    $.each(object, (key, value) => {
      this.versionList.push({
        versionId: value._source.systemHeader.versionId,
        createdDate: value._source.systemHeader.createdDate,
      });
      const valueSource = value._source;
      valueSource._id = value._id;
      holderVersionDataObj.push(valueSource);
      this.numberOfVersions = this.key + 1;
      this.max = this.key + 1;
    });
    this.allVersionDataObj = holderVersionDataObj;
    this.type = 'reload';
    // this.fnLoadDataTable(this.allVersionDataObj, this.type);
    if (this.isHasTargetTableComponent) {
      this.checkDatatablesComponentDoneLoading(type);
    } else {
      this.fnLoadDataTable(this.allVersionDataObj, this.type);
    }
  }
  fnGetDocumentById(type) {
    this.isProcessing = true;
    const query =
      "{'query':{'bool':{'filter':[" +
      "{'term':{'documentId':'" +
      this.docId +
      "'}}]}}," +
      "'sort':[{'systemHeader.createdDate':{'order':'desc'}}]}";
    const searchOptions = {
      filter: query,
      includeAllVersions: true,
      page: 0,
      pageSize: 1000,
    };

    this.searchService.search(searchOptions).then(
      (data) => {
        // LOOPING THROUGH THE RESULTS IMPACTS PERFORMANCE OF THE SEARCH DRASTICALLY. ANY FILTERING SHOULD
        // BE DONE IN THE SEARCH QUERY SENT TO ELASTICSEARCH, SO NO LOOPING SHOULD BE ADDED HERE

        // just assign the scope value directly to the returned data with no modification
        this.isProcessing = false; // 14789
        this.isFirstReload = true;
        this.rawDocumentVersionList = data.data.hits.hits;
        this.fnProcessDocumentList(this.rawDocumentVersionList, 'reload');
        this.isFirstReload = false;
      },
      (err) => {
        this.isProcessing = false; // 14789
        console.log('error on Loading fnGetDocumentById Data:' + err);
      }
    );
  }
  pagingClickFunction(event) {
    if ('<<...>>'.split(event.currentTarget.textContent).length !== 2) {
      // $('#divChildTemplate' + this.fieldName + ' .pagination li').removeClass('active');
      const listLi = $(this.elRef.nativeElement).find('li[class*="page-item"]');
      for (const li of listLi) {
        li.classList.remove('active');
      }
    }

    const currentSelectedContent = event.currentTarget.textContent;
    const currentValueContent = Number(currentSelectedContent);
    if (!isNaN(currentSelectedContent)) {
      if (currentValueContent - 3 <= 1) {
        const pagingObject = [];
        for (let i = 0; i <= this.totalPaging - 1; i++) {
          if (i < 5) {
            pagingObject.push(i + 1);
          }
        }
        if (this.totalPaging > 5) {
          pagingObject.push('...');
          pagingObject.push(this.totalPaging);
        }
        this.pagingNo = pagingObject;
        $(event.currentTarget.parentElement).addClass('active');
      } else if (currentValueContent + 3 >= this.totalPaging) {
        this.pagingNo = [
          '1',
          '...',
          this.totalPaging - 4,
          this.totalPaging - 3,
          this.totalPaging - 2,
          this.totalPaging - 1,
          this.totalPaging,
        ];
        $(event.currentTarget.parentElement).addClass('active');
      } else if (currentValueContent - 3 > 1 && currentValueContent + 3 < this.totalPaging) {
        this.pagingNo = [
          '1',
          '...',
          currentValueContent - 1,
          currentValueContent,
          currentValueContent + 1,
          '...',
          this.totalPaging,
        ];
        $('#divChildTemplate' + this.fieldName + ' .pgCenter').addClass('active');
      }
      this.pagingLoadRecordFunction(event, null);
    }
    // Load paging table display functions here...
  }
  pagingPrevNextClickFunction(event) {
    if (!event || !event.currentTarget) {
      return;
    }
    const textContent = event.currentTarget.textContent;
    if ('<<>>'.split(textContent).length === 2) {
      const selectedCurrentElement = $('#divChildTemplate' + this.fieldName + ' .pagination .active');
      if (textContent === '>>') {
        const num = Number($(this.elRef.nativeElement).find('li.page-item.active').find('a').text());
        if (!(num === this.totalPaging)) {
          $('#divChildTemplate' + this.fieldName + ' .pagination .active')
            .next()
            .find('a')
            .trigger('click');
          const nextLink = $(this.elRef.nativeElement).find('li.page-item.active').nextAll('li.page-item:first').find('a');
          nextLink[0].click();
          // if (this.currentSelectedPage < this.totalPaging) {
          //   this.pagingLoadRecordFunction(null, this.currentSelectedPage + 1);
          // }
        }
      } else if (textContent === '<<') {
        if (this.currentSelectedPage > 1) {
          const prevLink = $(this.elRef.nativeElement).find('li.page-item.active').prevAll('li.page-item:first').find('a');
          prevLink[0].click();
          // this.pagingLoadRecordFunction(null, this.currentSelectedPage - 1);
        }
      }
    }
  }
  pagingInitFunction(totalPaging, totalRecord) {
    this.totalPaging = totalPaging;
    const pagingObject = [];
    for (let i = 0; i <= totalPaging - 1; i++) {
      if (i < 5) {
        pagingObject.push(i + 1);
      }
    }
    if (totalPaging > 5) {
      pagingObject.push('...');
      pagingObject.push(totalPaging);
    }
    this.pagingNo = pagingObject;
  }
  pagingLoadRecordFunction(event, initValue) {
    if (this.allVersionDataObj) {
      const objectDataSet = this.sclUtilAuditService.getObjectVersionData(
        this.allVersionDataObj,
        this.getUser.bind(this),
        this.formatTime.bind(this),
        this.getLabelsFromTemplate.bind(this),
        this.resultUserDataObj,
        this.shouldIncludeField.bind(this),
        this.currentTemplateComponentsObj,
        this.isHasTargetTableComponent
      );
      const selectedRow = initValue ? initValue : Number(event.currentTarget.parentElement.textContent);
      const selectedFrom = selectedRow * 10 - 10;
      let selectedTo = selectedRow * 10 - 1;
      const totalRecord = objectDataSet.length;
      selectedTo = selectedTo > totalRecord ? totalRecord : selectedTo;
      this.rowItemsPagination = [];
      const rowSelectedObject = [];
      for (let i = selectedFrom; i <= selectedTo; i++) {
        const iData = this.dataUseLabel(objectDataSet[i]); //  14789
        rowSelectedObject.push(iData);
      }
      this.rowItemsPagination = rowSelectedObject;
      this.currentSelectedPage = selectedRow;
      this.cdRef.detectChanges();
    }
  }
  /** End of custom pagination */

  // begin 14789
  dataUseLabel(data) {
    if (this.useLabels && data !== null && Array.isArray(data)) {
      const newData = [];
      for (const iData of data) {
        if (iData !== null && typeof iData === 'string') {
          if (iData.indexOf(':') < 0) {
            newData.push(iData);
          } else {
            const sData = iData.split(':');
            const key = sData[0];
            if (key === 'documentId' || key === 'systemHeader' || key === '_id') {
              newData.push(iData);
            } else {
              let hasLabel = false;
              for (const comp of this.template.components) {
                if (key === comp.name) {
                  let sRemain = '';
                  for (let k = 1; k < sData.length; k++) {
                    sRemain += sData[k] + (k === sData.length - 1 ? '' : ':');
                  }
                  const iNewData = comp.label + ':' + sRemain;
                  newData.push(iNewData);
                  hasLabel = true;
                  break;
                }
              }
              if (hasLabel === false) {
                newData.push(iData);
              }
            }
          }
        } else {
          newData.push(iData);
        }
      }
      return newData;
    } else {
      return data;
    }
  }
  // end 14789

  // other logic for angular version
  isObject(val) {
    return typeof val === 'object';
  }
}
